import Input from "./Input";

const IcoInput = ({ input, meta, onICOChange, ...rest }) => {
  const wrappedInput = {
    ...input,
    onBlur: (val) => {
      if (input.onBlur) input.onBlur(val);
      if (onICOChange) onICOChange(val);
    }
  };
  return <Input input={wrappedInput} meta={meta} {...rest} />;
};

export default IcoInput;